import Link from 'next/link';
import React, { useRef, useState } from 'react'
import SearchSvg from '../ui-kit/icons/SearchSvg';

const TopNavSearch: React.FC = (props) => {

  const search = (e) => {
    e.preventDefault();
  }

  return (
    <Link href="/proyectos">
      <a>
        <div className="text-gray-400 rounded flex flex-row items-center border-2 border-secondary pl-2 pr-16 hover:cursor-pointer py-1">
          <SearchSvg className="w-5 h-5 stroke-current text-current stroke-2 mr-2" /> Buscar proyecto
        </div>
      </a>
    </Link>
  )
}


export default TopNavSearch;